import { render, staticRenderFns } from "./PositionList.vue?vue&type=template&id=03eda8a0"
import script from "./PositionList.vue?vue&type=script&lang=ts"
export * from "./PositionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports